module.exports = __webpack_public_path__ + "img/henxian-you.27dca876.gif";